/// Ce script gère la fonctionnalité -/+ d'un input number
/// (ex. : nombre de voyageurs de la demande de devis)

/// ----------------------------------------------------------------------------------
/// CLASS stepNumber
///
/// Création : 23 novembre 2023
/// Dernière révision : 8 janvier 2024
/// URL : /devis/${typeDevis} | /informations/newsletter | XXX
///
/// Description :
/// Pas à pas input[number]
/// - minimum & maximum values
/// - configurable step size
/// - keyboard input
///
/// ----------------------------------------------------------------------------------

class stepNumber {
	constructor(config) {
		// !todo config par défaut
		// !todo gestion NaN
		this.config = config;
	}

	initialize() {
		let self = this;

		this.setInputButtonState();

		document.querySelectorAll('[data-operation]').forEach(el => el.addEventListener('click', (e) => {
			self.setNumber(e)
		}))
		document.querySelectorAll('[data-operation]').forEach(el => {
			el.addEventListener('input', () => {
				self.setInputButtonState();
			})
			el.addEventListener('blur', (e) => {
				self.handleNumberInputBlur(e)
			})
		})
	}


	setInputButtonState() {
		const inputs = document.getElementsByClassName("number-input-text-box");

		for (let input of inputs) {
			if (input.id.length > 0) { // during value transition the old input won't have an id
				const value = input.value;
				const parent = input.parentElement.parentElement;

				if (parent.children[0] && input.hasAttribute("min"))
					parent.children[0].disabled = value <= parseFloat(input.min);

				if (parent.children[2] && input.hasAttribute("max"))
					parent.children[2].disabled = value >= parseFloat(input.max);
			}
		}
	}

	setNumber(event) {
		let button = event.target;
		let input = document.getElementById(button.dataset.inputId);

		if (input) {
			let value = parseFloat(input.value);
			let step = parseFloat(input.dataset.step);

			if (button.dataset.operation === "decrement") {
				value -= isNaN(step) ? 1 : step;
			} else if (button.dataset.operation === "increment") {
				value += isNaN(step) ? 1 : step;
			}

			if (input.hasAttribute("min") && value < parseFloat(input.min)) {
				value = input.min;
			}

			if (input.hasAttribute("max") && value > parseFloat(input.max)) {
				value = input.max;
			}

			if (input.value !== value) {
				this.setInputValue(input, value);
				this.setInputButtonState();
			}
		}
	}

	setInputValue(input, value) {
		let newInput = input.cloneNode(true);
		const parentBox = input.parentElement.getBoundingClientRect();

		input.id = "";

		newInput.value = value;

		if (value > input.value) {
			// right to left
			input.parentElement.appendChild(newInput);
			input.style.marginLeft = -parentBox.width + "px";
		} else if (value < input.value) {
			// left to right
			newInput.style.marginLeft = -parentBox.width + "px";
			input.parentElement.prepend(newInput);
			window.setTimeout(function () {
				newInput.style.marginLeft = 0
			}, 20);
		}

		window.setTimeout(function () {
			input.parentElement.removeChild(input);

			if(helpers.elementExist('.box__choices')) {
				document.querySelector('.box__choices').dispatchEvent(
					new CustomEvent('updateInputNumber', {
						bubbles: true,
						detail: {
							libelle: () => {
								return input.value
							}
						}
					})
				);
			}

		}, 250);
	}

	handleNumberInputBlur(event) {
		const value = event.target.value;

		if (event.target.hasAttribute("min") && value < parseFloat(event.target.min))
			event.target.value = event.target.min;

		if (event.target.hasAttribute("max") && value > parseFloat(event.target.max))
			event.target.value = event.target.max;
	}
}